import { Center, Flex } from "@chakra-ui/react";
import { Toaster } from "@ui";
import { RouterProvider } from "react-router";
import "./App.css";
import { router } from "./routes";

const AppContent = () => {
  return (
    <>
      <Center>
        <Flex direction="column" minH="100vh" minW="100vw" overflow="hidden">
          <RouterProvider router={router} />
        </Flex>
      </Center>
      <Toaster />
      {/* Single shared portal for Glide Data Grid editor overlays.
          Must live outside any overflow/position ancestor. */}
      <div id="portal" />
    </>
  );
};

const App = () => {
  return <AppContent />;
};

export default App;
